
export const campers = [
  {
    id: 1,
    name: 'HYMER EXSIS-T',
    model: 'Hymer Exsis-T 580',
    type: 'Camping-Car Profilé',
    seats: 4,
    berths: 4,
    length: '7.39m',
    transmission: 'Automatique',
    fuel: 'Diesel',
    engine: '140 CH',
    pricePerDay: 179,
    image: 'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/6605e90be4d55f5464e0197bad74a5a9.jpeg',
    gallery: [
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/6605e90be4d55f5464e0197bad74a5a9.jpeg',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/2ad3c496c761a0c907fd02f52b03d5c8.jpeg',
      'https://public.readdy.ai/ai/img_res/8b0a2f327e89392263956a7788035414.jpg'
    ],
    description: 'Confort et qualité allemande pour explorer la Côte d\'Azur. Le Hymer Exsis-T offre un aménagement intelligent et tout l\'équipement nécessaire pour des vacances en toute liberté.',
    features: [
      'Lit central queen',
      'Salle de bain complète',
      'Cuisine équipée',
      'Panneau solaire',
      'Store extérieur',
      'Climatisation'
    ]
  },
  {
    id: 2,
    name: 'HYMER B-MC',
    model: 'Hymer B-MC T 600',
    type: 'Camping-Car Intégral',
    seats: 5,
    berths: 5,
    length: '7.49m',
    transmission: 'Automatique',
    fuel: 'Diesel',
    engine: '177 CH',
    pricePerDay: 219,
    image: 'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/41dfcd9696ec69f3b343542e543a8bb0.png',
    gallery: [
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/41dfcd9696ec69f3b343542e543a8bb0.png',
      'https://readdy.ai/api/search-image?query=Hymer%20B-MC%20T%20600%20integral%20motorhome%20spacious%20interior%20lounge%20area%2C%20panoramic%20windows%2C%20luxury%20furniture%2C%20modern%20kitchen%2C%20premium%20camper%20van%20living%20space%2C%20bright%20natural%20light&width=800&height=600&seq=camper2_interior&orientation=landscape',
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/815cd2228db47408eb659d36f7eb2fd9.jpeg'
    ],
    description: 'Le haut de gamme Hymer pour un confort maximal. Le B-MC Intégral offre espace, luminosité et équipements premium pour découvrir la Provence et la Côte d\'Azur en famille.',
    features: [
      'Lit pavillon électrique',
      'Salle de bain spacieuse',
      'Grande cuisine',
      'Panneau solaire',
      'Store électrique',
      'TV & WiFi'
    ]
  },
  {
    id: 3,
    name: 'CARAVANE CHATEAU',
    model: 'Château Caravane Premium',
    type: 'Caravane de Luxe',
    seats: 0,
    berths: 6,
    length: '8.50m',
    transmission: 'Remorque',
    fuel: 'N/A',
    engine: 'N/A',
    pricePerDay: 159,
    image: 'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/2ecf3be4ca1a32cda9bcd8b92d444cc1.jpeg',
    gallery: [
      'https://static.readdy.ai/image/0120cb1b742139d0603be3135507cada/2ecf3be4ca1a32cda9bcd8b92d444cc1.jpeg',
      'https://readdy.ai/api/search-image?query=luxury%20caravan%20interior%20spacious%20living%20room%2C%20elegant%20furniture%2C%20large%20windows%2C%20modern%20kitchen%20fully%20equipped%2C%20family%20caravan%20interior%20design%2C%20warm%20cozy%20atmosphere%2C%20premium%20holiday%20trailer&width=800&height=600&seq=camper3_interior&orientation=landscape',
      'https://readdy.ai/api/search-image?query=luxury%20caravan%20separate%20bedroom%2C%20double%20bed%2C%20wardrobe%20storage%2C%20soft%20lighting%2C%20elegant%20curtains%2C%20premium%20holiday%20trailer%20bedroom%2C%20comfortable%20family%20camping%20accommodation&width=800&height=600&seq=camper3_bedroom&orientation=landscape'
    ],
    description: 'Luxe et espace pour toute la famille. La Caravane Château offre un intérieur spacieux et raffiné, idéale pour des séjours prolongés sur les plus beaux campings de la Côte d\'Azur.',
    features: [
      'Chambre séparée',
      'Salle de bain complète',
      'Cuisine tout équipée',
      'Salon spacieux',
      'Store électrique',
      'Climatisation'
    ]
  }
];
